<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div class="faultBtn">
        <div
          :class="auditStatus === '00' ? 'active' : 'none'"
          @click="btnClick('00')"
        >
          待执行({{ stateCountMap["00"] || 0 }})
        </div>
        <div
          :class="auditStatus === '01' ? 'active' : 'none'"
          @click="btnClick('01')"
        >
          执行中({{ stateCountMap["01"] || 0 }})
        </div>
        <div
          :class="auditStatus === '02' ? 'active' : 'none'"
          @click="btnClick('02')"
        >
          执行完成({{ stateCountMap["02"] || 0 }})
        </div>
        <div
          :class="auditStatus === '20' ? 'active' : 'none'"
          @click="btnClick('20')"
        >
          执行中断({{ stateCountMap["20"] || 0 }})
        </div>
        <div
          :class="auditStatus === '10' ? 'active' : 'none'"
          @click="btnClick('10')"
        >
          已作废({{ stateCountMap["10"] || 0 }})
        </div>
      </div>
      <div class="btn-group">
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          @click="handleCreateTask"
          >创建任务</el-button
        >
        <el-button
          size="small"
          type="success"
          icon="el-icon-download"
          :loading="exportLoading"
          @click="handleExportExcel"
          >导出Excel</el-button
        >
         <el-button
            size="small"
            type="success"
            icon="el-icon-download"
            :loading="exportminxiLoading"
            @click="handlemingxiExportExcel"
            >导出发放明细</el-button
          >
      </div>
    </div>

    <GlobalTable
      ref="GlobalTable"
      v-if="refresh"
      v-loading="loading"
      :columns="tableColumns"
      :data="seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <!-- 执行情况 -->
      <el-table-column
        label="执行情况"
        slot="execInfo"
        align="center"
        width="200px"
      >
        <template slot-scope="{ row }">
          <div>
            <span
              v-if="row.execInfo"
              :style="{ color: row.failNum > 0 ? '#f56c6c' : '#67c23a' }"
            >
              {{ row.execInfo }}
            </span>
            <span v-else>--</span>
            <div
              style="color: #0981ff; cursor: pointer; text-decoration: underline; margin-top: 4px;"
              @click="viewDetail(row)"
            >
              详情
            </div>
          </div>
        </template>
      </el-table-column>

      <!-- 执行人 -->
      <el-table-column
        label="执行人"
        slot="execRunner"
        align="center"
        width="160px"
      >
        <template slot-scope="{ row }">
          <span>{{
            row.runningName && row.runningAccount
              ? row.runningName + "-" + row.runningAccount
              : row.runningName || row.runningAccount || "--"
          }}</span>
        </template>
      </el-table-column>

      <!-- 中断原因（执行中断 20） -->
      <el-table-column
        label="中断原因"
        slot="failureMsg"
        align="center"
        width="160px"
      >
        <template slot-scope="{ row }">
          <span style="color: #f56c6c;">{{ row.failureMsg || "--" }}</span>
        </template>
      </el-table-column>

      <!-- 作废人（已作废 10） -->
      <el-table-column label="作废人" slot="runningName" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.invalidName"
            >{{ row.invalidName }}-{{ row.invalidAccount }}</span
          >
          <span v-else>--</span>
        </template>
      </el-table-column>

      <!-- 作废原因（已作废 10） -->
      <el-table-column
        label="作废原因"
        slot="cancelReason"
        align="center"
        width="160px"
      >
        <template slot-scope="{ row }">
          <span style="color: #f56c6c;">{{ row.failureMsg || "--" }}</span>
        </template>
      </el-table-column>

      <!-- 执行时间 -->
      <el-table-column
        label="执行时间"
        slot="runningTime"
        align="center"
        width="160px"
      >
        <template slot-scope="{ row }">
          <span>{{ row.runningTime || "--" }}</span>
        </template>
      </el-table-column>

      <!-- 操作列 -->
      <el-table-column
        label="操作"
        slot="operation"
        align="center"
        width="200px"
      >
        <template slot-scope="{ row }">
          <!-- 待执行：未设定执行时间 -->
          <template v-if="auditStatus === '00' && !row.timeoutTime">
            <el-button
              size="mini"
              type="primary"
              round
              @click="handleExecute(row)"
              >执行任务</el-button
            >
            <el-button
              size="mini"
              type="danger"
              round
              @click="handleCancel(row)"
              >作废任务</el-button
            >
          </template>
          <!-- 待执行：已设定执行时间 -->
          <template v-else-if="auditStatus === '00' && row.timeoutTime">
            <el-button
              size="mini"
              type="warning"
              round
              @click="handleModifyTime(row)"
              >修改执行时间</el-button
            >
            <el-button
              size="mini"
              type="danger"
              round
              @click="handleCancel(row)"
              >作废任务</el-button
            >
          </template>
          <!-- 执行中断 -->
          <template v-else>
            <span>--</span>
          </template>
        </template>
      </el-table-column>
    </GlobalTable>

    <!-- 执行任务/修改执行时间弹窗 -->
    <el-dialog
      :title="executeDialogTitle"
      :visible.sync="executeDialogVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="executeDialogClosed"
    >
      <p class="execute-tip">
        说明：若选择立即执行，提交后系统将自动执行绩效发放，无法中断
      </p>
      <!-- <div style="display: flex; align-items: center; margin: 20px 0;">
        <span><span style="color: #ff7284;">*</span>设置生效时间：</span>
        <el-radio-group v-model="executeForm.effectiveType" @input="onEffectiveTypeChange">
          <el-radio label="01">立即生效</el-radio>
          <el-radio label="02">定时生效（选择日期零点生效）</el-radio>
        </el-radio-group>
      </div>
      <div v-if="executeForm.effectiveType === '02'" style="display: flex; align-items: center; margin: 20px 0;">
        <span><span style="color: #ff7284;">*</span>定时生效时间：</span>
        <div style="width: 300px; margin-left: 15px;">
          <el-date-picker
            v-model="executeForm.effectiveTime"
            type="date"
            value-format="timestamp"
            :picker-options="executePickerOptions"
            placeholder="选择日期"
            style="width: 200px;"
          />
        </div>
      </div> -->
      <div style="text-align: center;font-size: 16px;">
        是否确认立即执行任务？
      </div>
      <div style="margin: 20px 0; font-size: 14px;">
        本次任务所需资金：<span style="color: #ff7284; font-weight: bold;"
          >{{ currentRow.allAmountDesc || "--" }}，请确保账户余额充足</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="executeDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="btnLoading"
          @click="handleExecuteConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!-- 作废任务弹窗 -->
    <el-dialog
      title="作废任务"
      :visible.sync="cancelDialogVisible"
      :close-on-click-modal="false"
      width="430px"
      @closed="cancelDialogClosed"
    >
      <div class="cancel-tip">说明：作废后，该任务将不再执行</div>
      <el-form
        :model="cancelForm"
        :rules="cancelRules"
        ref="cancelForm"
        label-position="top"
      >
        <el-form-item label="作废原因" prop="failureMsg" required>
          <el-input
            v-model="cancelForm.failureMsg"
            type="textarea"
            :rows="4"
            placeholder="请输入作废原因，最多50字"
            maxlength="50"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelDialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="btnLoading"
          @click="handleCancelConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
export default {
  name: "Table",
  data() {
    return {
      refresh: true,
      loading: false,
      seachDataList: [],
      auditStatus: "00",
      stateCountMap: {},
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableColumns: [],
      executeDialogVisible: false,
      executeDialogTitle: "执行任务",
      executeForm: {
        effectiveType: "01",
        effectiveTime: "",
      },
      executePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      cancelDialogVisible: false,
      cancelForm: {
        failureMsg: "",
      },
      cancelRules: {
        failureMsg: [
          { required: true, message: "请输入作废原因", trigger: "blur" },
        ],
      },
      btnLoading: false,
      exportLoading: false,
      exportminxiLoading: false,
      currentRow: {},
    };
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  created() {
    this.buildColumns();
    this.handleCurrentChange();
  },
  watch: {
    SeachParams() {
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    buildColumns() {
      const statusColumnMap = {
        "00": {
          amountLabel: "总金额/发放成功金额",
          tail: [{ slotName: "execRunner" }, { slotName: "operation" }],
        },
        "01": {
          amountLabel: "总金额/发放成功金额",
          tail: [
            { slotName: "execRunner" },
            { label: "状态更新时间", prop: "updateTime" },
          ],
        },
        "02": {
          amountLabel: "发放成功总金额",
          tail: [
            { slotName: "execRunner" },
            { label: "状态更新时间", prop: "updateTime" },
          ],
        },
        "20": {
          amountLabel: "总金额/发放成功金额",
          tail: [
            { slotName: "execRunner" },
            { label: "状态更新时间", prop: "updateTime" },
            { slotName: "failureMsg" },
            { slotName: "operation" },
          ],
        },
        "10": {
          amountLabel: "总金额/发放成功金额",
          tail: [
            { slotName: "execRunner" },
            { label: "状态更新时间", prop: "updateTime" },
            { slotName: "runningName" },
            { slotName: "cancelReason" },
          ],
        },
      };
      const { amountLabel, tail } =
        statusColumnMap[this.auditStatus] || statusColumnMap["00"];
      this.tableColumns = [
        { label: "序号", type: "index", width: "60px" },
        { label: "任务单号", prop: "taskNo" },
        { label: "执行状态", prop: "stateName" },
        { label: amountLabel, prop: "amountDesc" },
        { slotName: "execInfo" },
        { label: "创建人", prop: "createName" },
        { label: "创建时间", prop: "createTime" },
        { slotName: "runningTime" },
        ...tail,
      ];
    },
    buildAmountDesc(row) {
      if (this.auditStatus === "02") {
        return (row.finishAmount || 0) + "元";
      }
      return (row.allAmount || 0) + "元/" + (row.finishAmount || 0) + "元";
    },
    fetchList() {
      this.refresh = false;
      this.loading = true;
      const params = {
        state: this.auditStatus,
        taskNo: this.SeachParams.taskNo || "",
        optAccount: this.SeachParams.optAccount || "",
        startTime: this.SeachParams.startTime || "",
        endTime: this.SeachParams.endTime || "",
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      _api
        .getPerformanceTaskPageList(params)
        .then((res) => {
          const data = res.data || {};
          const pageData = data.page || {};
          this.seachDataList = (pageData.records || []).map((row) => ({
            ...row,
            amountDesc: this.buildAmountDesc(row),
            allAmountDesc: (row.allAmount || 0) + "元",
          }));
          this.page.total = pageData.total || 0;
          this.page.pageNum = pageData.current || this.page.pageNum;
          this.stateCountMap = data.stateCountMap || {};
        })
        .finally(() => {
          this.loading = false;
          this.refresh = true;
          if (typeof this.SeachParams.disuseLoding === "function") {
            this.SeachParams.disuseLoding();
          }
        });
    },
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      this.fetchList();
    },
    btnClick(type) {
      this.auditStatus = type;
      this.page.pageNum = 1;
      this.buildColumns();
      this.handleCurrentChange();
    },
    handleCreateTask() {
      this.$router.push("/corSupPerManege/createPerformancePayout");
    },
    handleExportExcel() {
      const params = {
        state: this.auditStatus,
        taskNo: this.SeachParams.taskNo || "",
        optAccount: this.SeachParams.optAccount || "",
        startTime: this.SeachParams.startTime || "",
        endTime: this.SeachParams.endTime || "",
      };
      this.exportLoading = true;
      _api
        .exportPerformanceTaskExcel(params)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "绩效发放列表.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
      handlemingxiExportExcel() {
      this.exportminxiLoading = true;
       const params = {
        state: this.auditStatus,
        taskNo: this.SeachParams.taskNo || "",
        optAccount: this.SeachParams.optAccount || "",
        startTime: this.SeachParams.startTime || "",
        endTime: this.SeachParams.endTime || "",
      };
      _api
        .exportPerformanceexportDetailExcel(params)
        .then((res) => {
          console.log(res);
          const content = res;
          const blob = new Blob([content]);
          let reader = new FileReader(); // 创建读取文件对象
          reader.addEventListener("loadend", () => {
            try {
              let data = JSON.parse(reader.result);
              if (data.code === 0) {
                MessageBox.alert(data.msg, "错误提示", {
                  type: "error",
                });
              }
            } catch (err) {
              const fileName = "绩效发放任务明细.xlsx";
              if ("download" in document.createElement("a")) {
                // 非IE下载
                const elink = document.createElement("a");
                elink.download = fileName;
                elink.style.display = "none";
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
              } else {
                // IE10+下载
                navigator.msSaveBlob(blob, fileName);
              }
            }
          });
          reader.readAsText(blob, "utf-8");
        })
        .finally(() => {
          this.exportminxiLoading = false;
        });
    },
    handleExecute(row) {
      this.currentRow = row;
      this.executeDialogTitle = "执行任务";
      this.executeDialogVisible = true;
    },
    handleModifyTime(row) {
      this.currentRow = row;
      this.executeDialogTitle = "修改执行时间";
      this.executeDialogVisible = true;
    },
    onEffectiveTypeChange(val) {
      if (val === "01") {
        this.executeForm.effectiveTime = "";
      }
    },
    handleExecuteConfirm() {
      // if (!this.executeForm.effectiveType) {
      //   return this.$message.error("请选择设置生效时间方式！");
      // }
      // if (this.executeForm.effectiveType === "02" && !this.executeForm.effectiveTime) {
      //   return this.$message.error("请选择定时生效时间！");
      // }
      this.btnLoading = true;
      // 待对接接口
      _api
        .runningPerformanceTask({ taskNo: this.currentRow.taskNo })
        .then(() => {
          this.$message.success("操作成功");
          this.executeDialogVisible = false;
          this.handleCurrentChange();
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
    executeDialogClosed() {
      this.executeForm.effectiveType = "01";
      this.executeForm.effectiveTime = "";
      this.currentRow = {};
    },
    handleCancel(row) {
      this.currentRow = row;
      this.cancelDialogVisible = true;
    },
    handleCancelConfirm() {
      this.$refs.cancelForm.validate((valid) => {
        if (!valid) return;
        this.btnLoading = true;
        _api
          .invalidPerformanceTask({
            taskNo: this.currentRow.taskNo,
            failureMsg: this.cancelForm.failureMsg,
          })
          .then(() => {
            this.$message.success("作废成功");
            this.cancelDialogVisible = false;
            this.handleCurrentChange();
          })
          .finally(() => {
            this.btnLoading = false;
          });
      });
    },
    cancelDialogClosed() {
      this.cancelForm.failureMsg = "";
      this.$refs.cancelForm && this.$refs.cancelForm.resetFields();
    },
    viewDetail(row) {
      this.$router.push({
        path: "/corSupPerManege/performancePayoutDetail",
        query: { taskNo: row.taskNo ,state:this.auditStatus},
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  .button_top {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .btn-group {
    display: flex;
    gap: 10px;
  }

  .execute-tip {
    color: #f56c6c;
    font-size: 13px;
    margin-bottom: 16px;
  }

  .cancel-tip {
    color: #f56c6c;
    font-size: 13px;
    margin-bottom: 16px;
  }

  .faultBtn {
    height: 34px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;

    .active {
      text-align: center;
      color: white;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981ff;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }
}
</style>
